module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/profile_page/skill-dd0a0a2f7269787b37092f5ad8837f17.png";